//Plus Icon tabs for product AIR page
 jQuery('.attachment-points-icon').on("click", function() {
   
                jQuery('.attachment-points-item').removeClass('active');
                jQuery(this).parent().parent().addClass('active');
                  var dataanchor =  jQuery(this).parent().parent().attr('data-anchor');
                  jQuery('.attachment_content').css("display","none");
                   jQuery('.attachment_content.'+dataanchor).css("display","block");

                    jQuery('.attachment_contentMob').css("display","none");
                   jQuery('.attachment_contentMob.'+dataanchor).css("display","block");

      });


//jQuery('buy-buttons.buy-buttons').hover(function () {
jQuery('buy-buttons.buy-buttons').on('touchstart', function (e) {
console.log('here btnstart');
    var link = jQuery(this); //preselect the link
 link.addClass('buybtnCls');
  
  //  jQuery(this).addClass('buybtnCls');

});
jQuery('buy-buttons.buy-buttons').mouseleave(function() {

    jQuery(this).removeClass('buybtnCls');

});
jQuery('buy-buttons.buy-buttons').click(function () {
    jQuery(this).addClass('buybtnCls');
    
});

jQuery(document).on('ready', function() {
    jQuery(this).removeClass('buybtnCls');

  // slick slider for videos
    jQuery('.works-slideshow .team-item').each(function() {
      var slider = jQuery(this);
      slider.slick({
      arrows: true,
      dots: false,
      accessibility: false,
      infinite: true,
      autoplay: false,
      
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

    // var sLightbox = jQuery(this);
    // sLightbox.slickLightbox({
    //   src: 'src',
    //   itemSelector: '.video-popup iframe'
    // });
  });

  //disable crousal product gallery
 // jQuery('.product-gallery__media-list-wrapper .product-gallery__media').click(function(){return false;});


  	jQuery('.video_pro_slider .team-image img').on("click", function() {
 
  // get required DOM Elements
    var iframe_src = jQuery(this).attr('video-src');
     var iframe = jQuery('.video-popup');
     var iframe_video = jQuery('.video-popup iframe');
     //close_btn = jQuery('body , .close-video');
     var iframe_src = iframe_src + '?autoplay=1&rel=0'; // for autoplaying the popup video
      
  // change the video source with the clicked one
   jQuery('.video-popup iframe').attr('src', iframe_src);
   jQuery('.video-popup').addClass('show-video');
   jQuery('body').addClass('overflow_body');
   jQuery('.slick-prev').css('display','none');
   jQuery('.slick-next').css('display','none');
  });
  // remove the video overlay when clicking outside the video
  jQuery('.close-video').on('click', function() {
     jQuery('.video-popup').removeClass('show-video');
     jQuery('.slick-prev').removeClass('show-video');
     jQuery('body').removeClass('overflow_body');
     jQuery('.video-popup iframe').attr('src', '');
     jQuery('.slick-prev').css('display','block');
     jQuery('.slick-next').css('display','block');
		});	
    });


// redirect add to cart to checkout
 jQuery(document).on('ready', function() {
  jQuery('.product-info__buy-buttons button.button').click(function(){  
 setTimeout(function () {
 
$.getJSON('/cart.js', function(cart)
 {
         console.log(cart);

    });
     window.location.href = "/checkout";
  }, 1400);
  });
 });

// add to checkout
//   jQuery('button.view_products').click(function(event){  
//   event.preventDefault();
// var product_ID = $(this).parents().find('.variants_id').val();
//      jQuery.ajax({
//       url: "/cart/add",
//       type: "post",
//         data:{
//               id:product_ID,
//               quantity:1
//             },
//       success: function(){ 
//        window.location.href = "/checkout";
//       },
//       error: function(){
//       }
//      });
// });

  
  jQuery(".product-info__button.show_for_mobile.show_mob_popup button").on("click", function() {
  jQuery(".popup-overlay_forMob, .popup-content_forMob").addClass("active");
});

//removes the "active" class to .popup and .popup-content when the "Close" button is clicked 
jQuery(".close_forMob, .popup-overlay_forMob").on("click", function() {
  jQuery(".popup-overlay_forMob, .popup-content_forMob").removeClass("active");
});



function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
jQuery('label.color-swatch.rounded-full').click(function() { 
 
   setInterval(function(){
   jQuery('.product-info__buy-buttons-custom input.variants_id').val(getUrlVars()["variant"]);
 
  
},1000);
})

  
 jQuery('details.product-info__accordion.accordion.group').click(function(){

  jQuery('details.product-info__accordion.accordion.group').each(function(){
   jQuery(this).addClass('customOpn').removeClass('customOpn');
 
  });
  });



//for mobile devices
jQuery(document).ready(function () {
  jQuery(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();
      function checkScreenSize(){
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 768) {
           jQuery('.product .show_for_desktop').remove();
         }
       }
  });




